/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRank6S = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M10.907 12.638a3.653 3.653 0 0 0-.037.52c0 .414.103.737.31.97.207.234.493.35.86.35.36 0 .643-.12.85-.36.213-.24.32-.566.32-.98 0-.26-.043-.483-.13-.67a.969.969 0 0 0-.37-.44c-.16-.106-.35-.16-.57-.16-.293 0-.553.08-.78.24a1.48 1.48 0 0 0-.453.53z" />
        <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-.412-11.043c.27-.153.571-.229.902-.229.453 0 .843.097 1.17.29.333.194.587.467.76.82.18.354.27.777.27 1.27 0 .527-.11.987-.33 1.38-.213.387-.52.687-.92.9-.393.214-.86.32-1.4.32-.553 0-1.03-.103-1.43-.31a2.217 2.217 0 0 1-.91-.91c-.207-.393-.31-.866-.31-1.42 0-.453.1-.943.3-1.47a7.017 7.017 0 0 1 .87-1.56l1.18-1.63h1.66l-1.3 1.79a12.8 12.8 0 0 0-.512.759z" />
      </g>
    </g>
  </Icon>
);
export { SvgRank6S as Rank6S };
